import TxpDataRow from '../../schema/viewSchema/TxpDataRow';

/**
 * Create a data row for the TxP card component given text, label and icon parameters.
 */

export default function createTxpDataRow(
    text: string,
    label?: string,
    icon?: string,
    isRequired?: boolean,
    placeholder?: string,
    includeToolTip?: boolean
): TxpDataRow {
    return text != null
        ? ({
              text: text,
              label: label,
              icon: icon,
              isRequired: isRequired,
              placeholder: placeholder,
              includeToolTip: includeToolTip,
          } as TxpDataRow)
        : null;
}
